import { createQueryKeys } from "@lukemorales/query-key-factory";
import { PostModel } from "common/models/BaseModel";
import { IDropdownModel } from "common/models/IDropdownModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import {
  IDepartment,
  IDepartmentGridFilter,
  IDepartmentGridModel,
} from "./types";
import { IListResponse } from "common/models/GridModels";
import { departmentView } from "../types/departmentView";

export const department = createQueryKeys("department", {
  list: (postModel: PostModel<IDepartmentGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IDepartmentGridModel>>(
        endpoints.department.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IDepartment>(`${endpoints.department.getById}/${Id}`),
  }),

  getDepartmentValues: () => ({
    queryKey: ["GetDepartmentValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.department.getDepartmentValues),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () =>
      api.get<departmentView>(`${endpoints.department.view}/${Id}`),
  }),

  getDepartmentValuesByInstitute: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.department.getDepartmentValuesByInstitute}/${Id}`
      ),
  }),

  getDepartmentValuesWithInstituteCode: (Id: string | number) => ({
    queryKey: ["GetDepartmentValuesWithInstituteCode", Id],
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.department.getDepartmentValuesWithInstituteCode}/${Id}`
      ),
  }),
});
